<template>
  <template v-if="disabled">
    <slot/>
  </template>
  <div v-else :class="['d-flex align-items-center gap-0 overflow-hidden', isHorizontal ? 'flex-row' : 'flex-column']">
    <button
      v-if="!hideButtons"
      :class="['btn btn-flat px-1 scroller-button scroller-start-button', {hide:!showButtons}]"
      :disabled="!showStart"
      @click="scrollBy(-1)">
      <i :class="`bi-chevron-${isHorizontal ? 'left' : 'up'}`" />
    </button>
    <div class="position-relative overflow-hidden flex-grow-1">
      <div :class="['overflow-auto', {'hide-scrollbar': hideScrollbar}]" @scroll="onScroll" ref="scroller">
        <slot />
      </div>
      <BlurMask
        v-if="!hideBlur"
        :position="isHorizontal ? 'left' : 'top'"
        :color="color"
        :style="startStyle"
        @click="scrollBy(-1)"
      />
      <BlurMask
        v-if="!hideBlur"
        :position="isHorizontal ? 'right' : 'bottom'"
        :color="color"
        :style="endStyle"
        @click="scrollBy(1)"
      />
    </div>
    <button
      v-if="!hideButtons"
      :class="['btn btn-flat px-1 scroller-button scroller-end-button', {hide:!showButtons}]"
      :disabled="!showEnd"
      @click="scrollBy(1)">
      <i :class="`bi-chevron-${isHorizontal ? 'right' : 'down'}`" />
    </button>
  </div>
</template>

<script>
import BlurMask from "./BlurMask.vue";

export default {
  components: {BlurMask},
  props: {
    direction: {
      type: String,
      validator: value => ['x','y'].indexOf(value) >= 0,
      default: () => 'y'
    },
    color: String,
    disabled: Boolean,
    hideScrollbar: Boolean,
    hideButtons: Boolean,
    hideBlur: Boolean
  },
  data() {
    return {
      scrollPosition: 0,
      pageSize: 0,
      contentSize: 0,
      mutationObserver: new MutationObserver(() => {
        console.log(`Observed mutations`);
        this.onScroll()
      })
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.onScroll();
    });
    this.mutationObserver.observe(this.$el.parentElement, { attributes: true });
    setTimeout(() => {
      this.onScroll();
    }, 500);
  },
  beforeUnmount() {
    this.mutationObserver.disconnect();
  },
  computed: {
    isHorizontal() {
      return this.direction === 'x';
    },
    showButtons() {
      return this.contentSize > this.pageSize;
    },
    showStart() {
      return this.startSize > 0;
    },
    startSize() {
      return this.scrollPosition;
    },
    showEnd() {
      return this.endSize > 0;
    },
    endSize() {
      const end = this.contentSize - this.pageSize;
      return Math.floor(end - this.scrollPosition);
    },
    startStyle() {
      return `${this.direction === 'x' ? 'width' : 'height'}: ${this.scrollPosition}px`;
    },
    endStyle() {
      return this.endSize < 0 ? '' : `${this.direction === 'x' ? 'width' : 'height'}: ${this.endSize}px`;
    }
  },
  methods: {
    onScroll() {
      if (this.$refs.scroller) {
        this.scrollPosition = this.$refs.scroller[`scroll${this.direction === 'x' ? 'Left' : 'Top'}`];
        this.contentSize = this.$refs.scroller[`scroll${this.direction === 'x' ? 'Width' : 'Height'}`];
        this.pageSize = this.$refs.scroller[`offset${this.direction === 'x' ? 'Width' : 'Height'}`];

      } else {
        console.log(`Attempted to check scroll position, but scroller isn't ready`);
      }
    },
    scrollBy(inc) {
      const size = this.pageSize;
      let scrollOptions = {behavior:'smooth'};
      scrollOptions[this.direction === 'x' ? 'left' : 'top'] = inc * size;
      this.$refs.scroller?.scrollBy(scrollOptions);
    }
  }
}
</script>

<style>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.scroller-button {
  transition: margin 250ms;
  align-self: stretch;
  margin: 0;
}
.scroller-start-button.hide {
  margin-left: -24px;
}
.scroller-end-button.hide {
  margin-right: -24px;
}
</style>
